import api from "./axios";

export async function fetchDirectoryAlerts() {
  const res = await api.get("/admin/directory-alerts");
  return res.data;
}

export async function fetchDirectoryAlertOptions(alertId) {
  const res = await api.get(`/admin/directory-alerts/${alertId}/options`);
  return res.data;
}

export async function submitDirectoryAlertAction(alertId, payload) {
  const res = await api.post(`/admin/directory-alerts/${alertId}/action`, payload);
  return res.data;
}